import { render, staticRenderFns } from "./clientAnddistribution.vue?vue&type=template&id=18db4fa0&scoped=true"
import script from "./clientAnddistribution.vue?vue&type=script&lang=js"
export * from "./clientAnddistribution.vue?vue&type=script&lang=js"
import style0 from "./clientAnddistribution.vue?vue&type=style&index=0&id=18db4fa0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18db4fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18db4fa0')) {
      api.createRecord('18db4fa0', component.options)
    } else {
      api.reload('18db4fa0', component.options)
    }
    module.hot.accept("./clientAnddistribution.vue?vue&type=template&id=18db4fa0&scoped=true", function () {
      api.rerender('18db4fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/clientAnddistribution.vue"
export default component.exports